import React from 'react';
import { findDOMNode } from 'react-dom';
import {
  Button, Spin, Modal, List, Card, Icon, Pagination
} from 'antd';
import { inject, observer } from 'mobx-react';
import LazyLoad from 'react-lazy-load';
import { toJS } from 'mobx';
import Search from './caseSearch';
import base from '../../tool/base';
import Editor from 'for-editor'
import { findReadme } from '../../api/list';
import CaseApply from '../util/caseApply/index';
import util from '../../util';
import Tab from './tab/index';
import Portal from '../main/Portal';

const { confirm } = Modal;

const { isWeaver, getAccessToken } = util;
const store = [
  'listStore',
  'caseListStore',
  'homeStore',
]
@inject(...store)
@observer
class App extends React.Component {

  constructor(props) {
    super(props);
    this.scrollTop = 0;
    this.state = {
      width: document.body.clientWidth || 1200,
      visible: false,
      markdownValue: "",
      appDetail: {},
    }
  }

  componentDidMount() {
    const { caseListStore: { getCaseList, getTagsList, setOtherParams, clearSearchValue } } = this.props;
    const { listStore, caseListStore, homeStore, ...otherProps } = this.props;
    setOtherParams(otherProps);
    otherProps.demotype === 'workflowChart' && clearSearchValue();
    getCaseList({
      ...this.getParams(),
      ...otherProps,
    });
    getTagsList();
    // window.addEventListener('scroll', this.scrollHandler);
    window.addEventListener('resize', this.resizeHandler);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.caseType !== this.props.caseType || nextProps.demotype !== this.props.demotype) {
      const { caseListStore: { getCaseList, setOtherParams, clearSearchValue, initPage } } = this.props;
      const { listStore, caseListStore, homeStore, ...otherProps } = nextProps; 
      setOtherParams(otherProps);
      initPage();
      otherProps.demotype === 'workflowChart' && clearSearchValue();
      getCaseList({
        ...this.getParams(),
        ...otherProps,
      });
    }
  }

  componentWillUnmount() {
    // window.removeEventListener('scroll', this.scrollHandler);
    window.removeEventListener('resize', this.resizeHandler);
    const { caseListStore } = this.props;
    caseListStore.clear();
  }

  getParams = () => {
    const { caseListStore: { searchFormValue } } = this.props;
    let _searchFormValue = {...toJS(searchFormValue)};
    Object.keys(_searchFormValue).map(
      key => {
        _searchFormValue[key] || delete _searchFormValue[key]
      }
    )
    return _searchFormValue;
  }


  scrollHandler = e => {
    if (this.caseList) {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const docH = document.documentElement.offsetHeight || document.body.offsetHeight;
      const listH = findDOMNode(this.caseList).offsetHeight;
      if (scrollTop > this.scrollTop) { // 向上翻动
        const { caseListStore: { getCaseListAdd, params, pageNum, count, pageSize, loadMore } } = this.props;
        if (pageNum * pageSize < count && listH - scrollTop + 100 < docH && !loadMore) {
          getCaseListAdd({ ...params, ...this.getParams(), pageNum: pageNum + 1, pageSize });
        }
      }
      this.scrollTop = scrollTop;
    }
  }

  resizeHandler = () => {
    this.setState({ width: document.body.clientWidth });
  }
  apply = (appId, title, kb) => {
    const { caseListStore: { setApply, setState } } = this.props;
    setApply({appId, title, kb});
    setState({applyVisible: true});
  }

  previewCase = (appId) => {
    const { caseListStore: { getVisitLog } } = this.props;
    this.setState({
      visible: true,
    });
    getVisitLog({
      appId: appId,
    });
    this.findReadme({appId});
  }

  downloadFile = (id, folderId) => {    
    const url = `${window.server}/v5/ecode/download?id=${id}&access_token=${getAccessToken()}`;
    const { caseListStore: { params, getCaseList}, demotype } = this.props;
    base.callApi('/v5/ecode/downloadCount', 'POST', {appId: folderId}, 'json', 'text').then((data) => {
      if (data.status) {
        window.open(url);
        getCaseList({
          ...params,
          ...this.getParams(),
          demotype: demotype || "default",
        })
      } else {
        console.error("后端接口异常，请联系管理员！");
      }
    });
  }
  
  download = (id, folderId, maintain) => {

    maintain !== "n" ? 
    this.downloadFile(id, folderId)
    : confirm({
      type: "info",
      content: "此案例/应用目前为免费共享，可能存在一些bug缺陷，后续所有的维护（bug/需求）如果当地无法处理，均需要提交需求开发流程到公共组件团队。",
      onOk: () => {        
        this.downloadFile(id, folderId)
      }
    })    
  }

  findReadme = async params => {
    const { caseListStore: { getCaseList, params: caseParams }, demotype } = this.props;
    const res = await findReadme({
      ...params,
    });
    try {
      if (res.status) {
        this.setState({ markdownValue: res.readme });
        getCaseList({
          ...caseParams,
          ...this.getParams(),
          demotype: demotype || "default",
        }, false);
      } else {
        console.error('后端接口异常，请联系管理员！');
      }
    } catch (e) {
      console.error('接口错误：', e);
    }
  }
  getButtons = (item) => {
    const {caseType, demotype} = this.props;
    return (
      <div className='theme-card-title case-card-title'>
        <div className='case-card-title-top'>{item.title}</div>
        { (item.attr && item.attr.caseType === 'app') && <Button
            disabled={!isWeaver()}
            style={{ margin: '5px 20px' }}
            onClick={(e) => {
              this.apply(item.folderId, item.title, item.kbVersion);
            }}
          >
            <span style={{width: 60, display: "inline-block"}}>申请</span>
          </Button>
        } 
        {/* { (item.attr && item.attr.caseType === 'case') && <Button
            style={{ margin: '5px 20px' }}
            onClick={(e) => {
              this.download(e, item.id, item.folderId);
            }}
          >
            <span style={{width: 60, display: "inline-block"}}>下载{`(${item.downloadCounts < 100 ? item.downloadCounts : '99+'})`}</span>
          </Button>
        } */}
      </div>
    )
  }
  collect = id => {
    const { homeStore: { addCollectLoading, addCollect }, caseListStore: { getCaseList, params }, demotype } = this.props;
    if(!addCollectLoading) { 
      addCollect({appId: id}).then(data => 
        data.status && getCaseList({
          ...params,
          ...this.getParams(),
          demotype: demotype || "default",
        }, false)
      );
    }
  }
  onStars = (id) => {
    const { caseListStore: { setStars, starsLoading, getCaseList, params }, demotype } = this.props;
    if(!starsLoading) { 
      setStars({appId: id}).then(data => 
        data.status && getCaseList({
          ...params,
          ...this.getParams(),
          demotype: demotype || "default",
        }, false)
      );
    }
  }
  onPageChange = (pageNum, pageSize) => {
    const { caseListStore: { setState, getCaseList }, demotype } = this.props;
    setState({params: {pageSize, pageNum}})
    getCaseList({
      ...this.getParams(),
      demotype: demotype || "default",
    })
  }
  renderCaseGrid	= () => {
    const {
      caseType,
      caseListStore: { loading, caseList, loadMore }
    } = this.props;
    const titleStyle = {
      whiteSpace: 'nowrap',
      wordBreak: 'keep-all',
      overflow: 'hidden',
      width: '100%',
      textOverflow: 'ellipsis',
    }
    return (
      <List
        ref={c => this.caseList = c}
        grid={{ gutter: 16, column: 4 }}
        dataSource={caseList}
        loading={loading}
        loadMore={loadMore && <Spin spinning={true}><div style={{ width: '100%', height: 300 }} /></Spin>}
        locale={{
          emptyText: (
            <div style={{minHeight: 400, paddingTop: 120}}>
              <div className="icon-Cloud-No-data" />
              <p style={{ textAlign: 'center' }}>暂无数据</p>
            </div>
          )
        }}
        renderItem={item => (
          <List.Item
            style={{cursor: 'pointer'}}
          >
            <Card
              style={{ width: '100%' }} 
              className="home-page-theme-list-item-card"
            >
              <img className="home-page-case-list-item-meta-image" src={item.imageList && item.imageList[0].imageLink} alt='' />
              <div className='theme-card-mask' />
              {this.getButtons(item)}
            </Card>
            <div className="home-page-theme-e9Info-num" key="home-page-theme-e9Info-num">
                <span className="home-page-theme-e9Info-num-left">
                  <Icon type="eye" className="home-page-theme-e9Info-num-icon" />
                  {item.visits || 0}
                </span>
                <span className="home-page-theme-e9Info-num-left" onClick={() => caseType !== "app" && this.download(item.id, item.folderId, item.maintain)}>
                  <Icon type="download" className="home-page-theme-e9Info-num-icon" />
                  {item.downloadCounts || 0}
                </span>
                <span className="pointer" onClick={() => this.onStars(item.folderId)}>
                  <Icon type="like" className={`home-page-theme-e9Info-num-icon ${item.thumbsupStatus === 'y' ? "heart-active" : ""}`} theme={item.thumbsupStatus === 'y' ? "filled" : "" } />
                  {item.thumbsup || 0}
                </span>
                <div className="home-page-theme-e9Info-desc">
                  <span 
                    className="home-page-theme-e9Info-desc-single" 
                    onClick={() => this.collect(item.folderId)}
                  >
                    {item.starStatus === 'y' ? '取消收藏' : '收藏'}
                  </span>
                  {
                    item.attr && item.attr.detailsUrl && item.attr.detailsUrl !== '' && (
                      <span className="home-page-theme-e9Info-desc-single" onClick={() => window.open(item.attr.detailsUrl)}>
                        详情
                      </span>
                    )
                  }
                  {
                    item.attr && item.attr.previewUrl && item.attr.previewUrl !== '' && (
                      <span className="home-page-theme-e9Info-desc-single" onClick={() => window.open(`${item.attr.previewUrl}&ecodessoid=test`)}>
                        预览
                      </span>
                    )
                  }
                </div>
              </div>
            <div
              className="home-page-case-list-item-meta"
              
            >
              <div title={item.title} className="home-page-case-list-item-meta-title ellipsis">{item.title}</div>
            </div>
          </List.Item>
        )}
      />
    );
  }
  onCancel = () => {
    const { caseListStore: { initApply } } = this.props;
    this.setState({visible: false, markdownValue: ''});
    initApply();
  }
  onFormChange = (changed, allValues) => {
    const { caseListStore: { setApply } } = this.props;
    setApply({...changed});
  }
  render() {
    const {
      caseListStore: { searchLoading, setState, applyVisible, count, params: { pageNum, pageSize } },
      demotype,
      caseType,
      tabTitle
    } = this.props;
    const { visible, markdownValue } = this.state;
    return (
      <div className='home-page-theme-list home-page-case'>
        <Tab title={tabTitle || (caseType === "app" ? '开发应用' : '开发案例')} span={24} offset={0} more={false}/>
        {
          searchLoading ? <Spin spinning={searchLoading}><div style={{ width: '100%', height: 300 }} /></Spin>
          : <Search onChange={value => setState({searchFormValue: value})} demotype={demotype} workflowChart={demotype === 'workflowStyle'} />
        }
        {this.renderCaseGrid()}
        {
          count > 0 && 
            <Pagination
              className="home-page-case-page"
              pageSize={pageSize}
              current={pageNum}
              total={count}
              onChange={this.onPageChange}
              onShowSizeChange={this.onPageChange}
              pageSizeOptions={['8', '16', '24', '32']}
              showSizeChanger
              showQuickJumper
            />
        }
        <Modal
            title="预览"
            visible={visible}
            bodyStyle={{
              padding: 0,
              height: 520,
            }}
            style={{
              top: 50,
            }}
            maskClosable={false}
            width={900}
            onCancel={this.onCancel}
            footer={
              <Button type="primary" className="home-page-preview-button" onClick={this.onCancel}>关闭预览</Button>
            }
        >
          {markdownValue ? 
            <Editor
              value={markdownValue}
              preview
              toolbar={{}}
              style={{
                height: '100%',
                borderRadius: 0,
                border: 'none'
              }}
            /> : 
            <Spin><div style={{ width: '100%', height: 500 }} /></Spin>
          }
      </Modal>
      <CaseApply workflowChart={demotype === 'workflowChart'} visible={applyVisible} onCancel={() => setState({applyVisible: false}) } onFormChange={this.onFormChange} />
    </div>
    );
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/home/Case.js